
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Target } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface TestCardProps {
  id: string;
  title: string;
  description: string;
  icon: string;
  onSelectTest: (testId: string) => void;
  className?: string;
  favoriteButton?: React.ReactNode;
}

const TestCard = ({
  id,
  title,
  description,
  icon,
  onSelectTest,
  className,
  favoriteButton
}: TestCardProps) => {
  const { t } = useTranslation('training');
  
  return (
    <Card
      className={cn(
        "cursor-pointer hover:border-golf-600 transition-colors relative overflow-hidden",
        className
      )}
    >
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-xl mr-2">{icon}</span>
            <CardTitle className="text-lg">{title}</CardTitle>
          </div>
          {favoriteButton && (
            <div onClick={(e) => e.stopPropagation()}>
              {favoriteButton}
            </div>
          )}
        </div>
      </CardHeader>
      <CardContent className="text-sm text-gray-600">
        <CardDescription className="mb-4">{description}</CardDescription>
      </CardContent>
      <CardFooter className="pt-0 pb-4">
        <Button 
          className="w-full bg-green-600 hover:bg-green-700 text-white"
          onClick={() => onSelectTest(id)}
        >
          {t('level3.selectButton')}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default TestCard;
